import { toDate } from '@/features/shared/format'
import type { MailMessage } from './mailTypes'

/**
 * API tarihi `DD.MM.YYYY HH:mm:ss` gönderir; metin olarak karşılaştırmak günü önce sıralar
 * ("05.11.2025" < "26.10.2026" ama "30.09.2025" > "26.10.2026"). Sıralama zaman damgasıyla yapılır.
 */
const stamp = (m: Pick<MailMessage, 'created_at'>) => toDate(m.created_at)?.getTime() ?? 0
const newestFirst = (a: MailMessage, b: MailMessage) => stamp(b) - stamp(a)

export const MAILBOX_ADDRESS = 'destek@urunver.com'

export function normalizeSubject(subject: string): string {
  return subject
    .replace(/^(re|fw|fwd|ynt|ilt):\s*/gi, '')
    .trim()
    .toLowerCase()
}

export function threadIdForMessage(msg: Pick<MailMessage, 'subject' | 'thread_id' | 'id'>): string {
  if (msg.thread_id) return msg.thread_id
  const base = normalizeSubject(msg.subject)
  return base ? `thread-${base}` : msg.id
}

export function resolveThreadId(subject: string, existing?: string): string {
  if (existing) return existing
  const base = normalizeSubject(subject)
  return base ? `thread-${base}` : `thread-${Date.now().toString(36)}`
}

export function getThreadMessages(messages: MailMessage[], anchor: MailMessage): MailMessage[] {
  const tid = threadIdForMessage(anchor)
  return messages
    .filter((m) => threadIdForMessage(m) === tid)
    .sort((a, b) => stamp(a) - stamp(b))
}

export function isOutgoingMessage(msg: MailMessage): boolean {
  return msg.from === MAILBOX_ADDRESS || msg.folder === 'SENT' || msg.folder === 'DRAFT'
}

/** One row per thread: keep the newest message that passes the filter. */
export function collapseToThreadList(items: MailMessage[]): MailMessage[] {
  const byThread = new Map<string, MailMessage>()
  const sorted = [...items].sort(newestFirst)
  for (const m of sorted) {
    const tid = threadIdForMessage(m)
    if (!byThread.has(tid)) byThread.set(tid, m)
  }
  return [...byThread.values()].sort(newestFirst)
}

export function threadMessageCount(messages: MailMessage[], anchor: MailMessage): number {
  return getThreadMessages(messages, anchor).length
}
